import FieldEntityType from "shared/form/renderer/enums/EntityType";
import FieldFetchType from "shared/form/renderer/enums/FieldFetchType";
import FieldIdentifier from "shared/form/renderer/enums/FieldIdentifier";
import FieldType from "shared/form/renderer/enums/FieldType";
import FieldRenderType from "shared/form/renderer/enums/FieldRenderType";
import { Copies } from "shared/hooks/useCopies";
import { ApiApplicableRateCardDetails } from "../../../../shared/types/ApiApplicableRateCardDetails";
import { getOptionsForBulkQuantity } from "../../../../shared/components/bulkQuantityPriceBreakUpMap/util";
import { ApiAmount } from "shared/types/ApiAmount";
import { getFormattedCurrency } from "shared/utils";
import FieldAlias from "shared/form/renderer/enums/FieldAlias";

export function getBulkTicketQuantitySchema(
  copies: Copies,
  applicableRates: Array<ApiApplicableRateCardDetails>,
  selectedQuantity?: number,
  selectedBulkTicketUnitPriceAmount?: ApiAmount,
  preSelectIndexWithOptions?: boolean
) {
  const options = selectedBulkTicketUnitPriceAmount
    ? [
        {
          id: `${selectedQuantity}`,
          value: copies.get("bulk.tickets.per.ticket.price.option", {
            0: selectedQuantity,
            1: getFormattedCurrency(selectedBulkTicketUnitPriceAmount)
          }),
          customData: selectedBulkTicketUnitPriceAmount,
          uiVersion: 0,
          displayOrder: 0
        }
      ]
    : getOptionsForBulkQuantity({
        applicableRates,
        perTicketPriceStr: copies.get("bulk.tickets.per.ticket.price.option")
      });
  const preSelectedIndex = options.findIndex(o => Number(o.id) === selectedQuantity);
  const defaultIndex = preSelectIndexWithOptions && preSelectedIndex >= 0 ? preSelectedIndex : 0; //show first option as default

  return {
    alias: FieldAlias.BULK_TICKET_QUANTITY,
    children: [],
    conflictValue: null,
    defaultValue: options?.[defaultIndex]?.id,
    disabled: false,
    displayOrder: 0, // always show first
    entityType: FieldEntityType.PARTICIPANT,
    fetchStatic: null,
    fetchType: FieldFetchType.OPTION,
    id: FieldIdentifier.BULK_TICKET_QUANTITY,
    infoLabel: null,
    label: copies.get("number.of.tickets"),
    mandatory: true,
    maximum: 0,
    minimum: 0,
    options: options || [],
    placeholderLabel: undefined,
    platformField: true,
    renderType: FieldRenderType.BULK_TICKET_QUANTITY,
    secondaryLabel: null,
    showAlwaysForOrganization: false,
    showDecision: null,
    showMandatory: false,
    system: true,
    type: FieldType.PLATFORM,
    validationDecision: null,
    validationRegex: null,
    validationRegexMessage: null,
    value: selectedQuantity || null,
    uiOnlyField: true
  };
}
